<template>
  <div class="aboutcontainer">
    <div class="content">
      <div class="top">
        <div class="topleft">
          <div class="line"></div>
          <div class="title">公司简介</div>
          <div class="title">Company profile</div>
        </div>
        <!-- <div class="topright">
          <img :src="unicomImg" alt="">
        </div> -->
      </div>
      <div class="centerimg">
        <img :src="chanhu" alt="">
      </div>
      <div class="text">
        <p>深圳拓邦股份有限公司</p>
        <p><span class="yaer">1996</span>年成立于有中国科技“硅谷”之称的深圳高新技术产业园内。</p>
        <p>经过十几年的高速发展，拓邦现已发展成为以中国领先的智能控制技术为核心，不断拓展其应用领域的中国一流智能控制方案提供商。公司的智能控制器、直流无刷电机、空心杯电机及驱动器、动力锂电池、储能锂电池等产品广泛应用于家庭、工业、医疗等领域，销售遍及全球几十个国家。</p>
        <p>公司的智能控制器产品涵盖家用电器、医疗器械、工业控制、电动工具、家居护理、冰洗卫浴、驱动电源等相关智能控制产品。拓邦集研发、生产和销售于一身，拥有强大的研发团队和专业的自动化生产线，以及完善的售后服务体系；提供最优质智能控制解决方案和产品的同时，可提供JDM／ODM／EMS服务。</p>
        <p>
          公司已获得CNAS实验室认证，同时已通过TS16949：2009/ISO9001：2008质量管理体系、ISO14001：2004环境管理体系、OHSAS18001：2007职业健康安全管理体系认证；推广6SIGEMA、FMEA等国际先进的管理理念；已具备RoHS符合性的检测能力和完备的RoHS保障能力。
        </p>
        <p>2007年，拓邦股份在深圳证券交易所成功上市（股票代码002139），作为一家充满社会责任感的公众上市公司，拓邦始终是企业与消费者的忠实伙伴。</p>
        <p>深圳拓邦股份有限公司是国家级高科技企业和深交所上市公司。拓邦目前拥有员工5000多人，占地近7.5万平方米，拥有深圳、杭州、惠州三个生产基地和重庆研发基地，2015年成立拓邦印度公司，2017成立宁波运营中心。</p>
        <p>拓邦坚守“创新”理念，致力于人们生活的显著改善，以使人们的生活更加舒适精彩、更加高效节能。我们与合作伙伴一道，为推动技术向前发展而不懈努力，使人们享受技术创新带来的变化。</p>
      </div>
    </div>
    <footBar></footBar>
  </div>
</template>
<script>
import footBar from '@/components/footbar'
// import unicomImg from '@/icon/images/aboutus_logo.png'
import chanhu from '@/assets/images/aboutus_pic.png'
export default {
  name: 'productList',
  computed: {

  },
  watch: {},
  components: {
    footBar
  },
  data() {
    return {
      // unicomImg: unicomImg,
      chanhu: chanhu
    }
  },
  methods: {

  }
}

</script>
<style rel="stylesheet/scss" lang="scss">
 @import "~styles/index.scss";
.aboutcontainer {
  padding: vw(20) 0 0 0;
  width: 100%;
  background-color: #F6F6F6;

  .content {
    padding: vw(55);
    text-align: center;
    margin: 0 auto;
    width: vw(1200);
    min-height: vw(900);
    /* height:900px;         */
    background-color: #ffffff;
    margin-bottom: vw(20);

    .top {
      height:vw(90);
      margin-bottom: vw(28);

      .topleft {
        float: left;

        .line {
          width: vw(49);
          height: 4px;
          background-color: #1cc0c9;
          border-radius: 2px;
          margin-bottom: vw(19);
        }

        .title {
          font-family: MicrosoftYaHei-Bold;
          font-size: vw(24);
          font-weight: normal;
          font-stretch: normal;
          line-height: vw(36);
          letter-spacing: 0px;
          color: #333333;
          text-align: left;
        }
      }

      .topright {
        float: right;
      }
    }

    .centerimg {
      text-align: center;
      margin: 0 auto;

    }

    .text {
      margin: 0 auto;
      margin-top: vw(41);
      width: vw(994);
      text-align: left;
      line-height: vw(36);

      .yaer {
        line-height: vw(32);
        font-size: vw(36);
        color: #008F9D;
        font-family: 'brandon_textbold';
      }

      p {
        // text-indent: 30px;
        line-height:vw(25);
        margin: vw(20) 0;
      }
    }

    .clearfloat {
      clear: both;
      height: 0;
      font-size: 1px;
      line-height: 0px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/about.vue